import { Injectable } from '@angular/core';
import { fromEvent } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class NotificationSound{
  // used in form Element component
  constructor( ) { }
  
  ngOnInit(){
    
  }


  sound(){
    const audio = new Audio('./assets/sounds/notification-sound.mp3'); // Chemin du fichier audio
    audio.play().then(() => {}).catch(error => {});
  }

}
